/**
 * セッションストレージのキー名
 */
export const SESSION_STORAGE_KEY = {
  /** 初回ログインコンバージョン発火済みフラグ */
  FIRST_LOGIN_FIRED: 'first_login_fired',
} as const;

/**
 * ローカルストレージのキー名（広告パラメータ用）
 */
export const AD_STORAGE_KEY = {
  /** 広告パラメータ保存キー */
  AD_PARAMS: 'ptbr_ad_params',
} as const;

/**
 * GAのカスタムイベント名
 */
export const GA_EVENT_NAME = {
  // UI言語切り替え
  CHANGE_UI_LANG: 'change_ui_lang',
  // 翻訳元言語切り替え
  CHANGE_SRC_LANG: 'change_src_lang',
  // 翻訳先言語切り替え
  CHANGE_DEST_LANG: 'change_dest_lang',
  // ゲスト画面キャンペーンポップアップ
  GUEST_CAMPAIGN: 'guest_campaign',
  // コンバージョンイベント
  FIRST_LOGIN: 'first_login',
} as const;

/**
 * ゲスト画面キャンペーンポップアップの表示条件
 */
export const GUEST_CAMPAIGN_DISPLAY_TYPE = {
  // ボタンクリックで表示
  BUTTON_CLICK: 'button_click',
  // 共有終了で表示
  SHARE_END: 'share_end',
} as const;
export type GuestCampaignDisplayType =
  (typeof GUEST_CAMPAIGN_DISPLAY_TYPE)[keyof typeof GUEST_CAMPAIGN_DISPLAY_TYPE];
